
import { HttpClient } from '@angular/common/http';
import { Component, Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-my-dialog',
  template: `

<div class="dialog-container">

  <h1 mat-dialog-title>
    <span class="title-content">
      <mat-icon>mail</mat-icon>
      {{ project.lifecycle.toUpperCase() }} {{ project.discriminator }} Feedback
    </span>
  </h1>


      <mat-dialog-content>
        <p>Tell us what you know about {{project.name}} ( {{project.discriminator}}ID: {{project.id}})</p>

        <form *ngIf=" !success">
          <!-- <mat-form-field appearance="fill">data.showForm &&
            <mat-label>Your Name</mat-label>
            <input matInput [(ngModel)]="name" name="name">
          </mat-form-field> -->
          <mat-form-field appearance="fill" style="width:100%">
            <textarea name="messageText"
                      [(ngModel)]="feedbackMessage.messageText"
                      rows="10">
            </textarea>
          </mat-form-field>
          <p *ngIf="error" class="error">There was an error and your message could not be sent. Please tell EICDataStream Product Support about this failure.</p>
        </form>

        <p *ngIf="success" class="success">Thank you for telling us more about this {{project.discriminator}}. A message has been sent to the team responsible for this industry sector.</p>
      </mat-dialog-content>

      <div mat-dialog-actions *ngIf="!success">
        <button mat-button class="submit-button" (click)="submit()">Send</button>
        <button mat-button class="close-button" (click)="close()">Cancel</button>
      </div>
    </div>
  `
  ,
  styles: [`
  /*
  // :host{
  //   --mat-app-headline-small-size:16px;
  //   --mdc-dialog-subhead-size:16px;
  // }
  /*
    /*
      Temporary workaround for Bootstrap/legacy typography
      interaction affecting Material dialogs.
      Remove when Bootstrap dependency is retired.
    */
    :host {

      /* Title */
      --mdc-dialog-subhead-size: 18px;
      --mdc-dialog-subhead-line-height: 24px;
      --mdc-dialog-subhead-weight: 500;

      /* Body */
      --mdc-dialog-supporting-text-size: 14px;
      --mdc-dialog-supporting-text-line-height: 20px;
      --mdc-dialog-supporting-text-weight: 400;
    }

    .title-content {
      display: flex;

      align-items: center; /* vertical centering */
      gap: 8px; /* space between icon and text */
    }

    .title-content mat-icon {
      vertical-align: middle;
    }

    .mat-mdc-dialog-content p {
      font-size: 14px;  
      color: var(--sys-on-surface);
    }

    .mat-mdc-dialog-content p.error {
      font-size: 14px;  
      color: var(--sys-error);
    }

    /* .mat-form-field  */
    textarea {
      color:black !important;
      font-size: 14px !important;
      width: 100%;
      box-sizing: border-box;
    }
    

  
    .success { color: var(--sys-on-surface); }
    .submit-button {
      background-color: var(--sys-primary-fixed-dim) !important;
      color: var(--sys-on-primary-fixed-variant) !important;
    }
    .close-button {
      background-color: var(--sys-secondary-fixed-dim) !important;
      color: var(--sys-on-secondary-fixed-variant) !important;
    }

    .dialog-container {
    background-color: var(--sys-surface-container-high);
    color: var(--sys-on-surface);
    padding: 8px;
    border-radius: 4px;
    }
`]

})
export class FeedbackDialogComponent {


  error: string | null = null;
  success = false;
  feedbackMessage: IFeedbackMessage = {
    projectID: 0,
    projectName: "",
    description1: "",
    description2: "",
    itemType: "",
    messageText: "",
    url: "",
  };

  constructor(
    private apiService: ApiService,
    private dialogRef: MatDialogRef<FeedbackDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public project: { id: number, name: string, lifecycle: string, discriminator: string },
    //@Inject(MAT_DIALOG_DATA) public feedbackMessge: IFeedbackMessage
  ) {

  }


  submit(): void {
    this.feedbackMessage.projectID = this.project.id,
      this.feedbackMessage.projectName = this.project.name,
      this.feedbackMessage.description1 = this.project.name,
      this.feedbackMessage.description2 = "",
      this.feedbackMessage.itemType = `${this.project.lifecycle.toUpperCase()} ${this.project.discriminator}`,
      this.feedbackMessage.url = "",


      (this.project.discriminator === 'Asset'
        ? this.apiService.submitOpexFeedback(this.feedbackMessage)
        : this.apiService.submitCapexFeedback(this.feedbackMessage))
        .subscribe({
          next: () => {
            this.success = true;
            // Optionally close after a delay
            setTimeout(() => this.dialogRef.close('success'), 1500);
          },
          error: (err) => {
            this.error = 'Submission failed. Please try again.';
            console.error('API error:', err);
          }
        });
  }


  close(): void {
    this.dialogRef.close();
  }

}


interface IFeedbackMessage {
  projectID: number;
  projectName: string;
  description1: string;
  description2: string;
  itemType: string;
  messageText: string;
  url: string;
}



@Injectable({ providedIn: 'root' })
export class ApiService {
  constructor(private http: HttpClient) { }

  submitCapexFeedback(feedbackMessage: IFeedbackMessage): Observable<any> {
    return this.http.post("/api/sendFeedbackMessage", feedbackMessage);
  }

  submitOpexFeedback(feedbackMessage: IFeedbackMessage): Observable<any> {
    return this.http.post("/api/sendFeedbackMessage/opex", feedbackMessage);
  }
}
